// extracted by mini-css-extract-plugin
export default {"confirm-field":"ResetPasswordConfirm_confirm-field__5eIco"};